<template>
  <div class="output-container">
    <div v-if="this.$store.state.completedLoading">
      <ul>
        <li v-for="item in this.$store.state.wholeDatabase" :key="item.uid" :id="item.uid">
          <a :href="`https://${this.$store.state.hostname}/film-archive?show=${item.uid}`">
            <span v-if="item.title_de">{{ item.title_de.replaceAll('\\', '').toUpperCase() }}</span>
            <span v-if="item.title_en && item.title_en !== item.title_de">&nbsp;/&nbsp;{{ item.title_en.replaceAll('\\', '').toUpperCase() }}</span>
            <span v-if="item.director.length > 0">
              <span> &nbsp; by &nbsp;</span>
                  <span v-for="dir in item.director" :key="dir">
                    <span v-html="dir.name"/>
                    <span v-if="item.director[item.director.length -1] !== dir">,&nbsp;</span>
                  </span>
            </span>
          </a>
        </li>
      </ul>
      <div>
          <span class="btn btn-primary" style="margin-top: 1rem" v-if="(this.$store.state.counter + 20) < this.$store.state.idForSearchRequest.length"
                @click="this.showMore()">Show more
          </span>
      </div>
    </div>
    <div v-if="!this.$store.state.completedLoading" class="loading">
      <svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
        <circle fill="#ff0000" stroke="none" cx="6" cy="50" r="6">
          <animate
              attributeName="opacity"
              dur="1s"
              values="0;1;0"
              repeatCount="indefinite"
              begin="0.1"/>
        </circle>
        <circle fill="#ff0000" stroke="none" cx="26" cy="50" r="6">
          <animate
              attributeName="opacity"
              dur="1s"
              values="0;1;0"
              repeatCount="indefinite"
              begin="0.2"/>
        </circle>
        <circle fill="#ff0000" stroke="none" cx="46" cy="50" r="6">
          <animate
              attributeName="opacity"
              dur="1s"
              values="0;1;0"
              repeatCount="indefinite"
              begin="0.3"/>
        </circle>
      </svg>
    </div>
  </div>
</template>

<script>
import LazyLoadDirective from '../../directives/LazyLoadDirective';

export default {
  directives: {
    lazyload: LazyLoadDirective,
  },
  methods: {
    // getModalId(id) {
    //   // Wird aufgerufen beim Klick auf einen Film -> führt zur Anzeige des Popups und verändert die URL
    //   // this.$store.commit('updateSelectedFilmCard', id);
    //   // this.$router.push({ path: this.$store.state.site, query: { show: id } });
    //   // eslint-disable-next-line no-restricted-globals
    // },
    showMore() {
      // Führt dazu dass 20 Filme mehr angezeigt werden - Das Laden der Filme passiert in Searchbar
      this.$store.commit('updateCounter', 20);
    },
  },
};
</script>
<style lang="css">

#filmcategory, #filmgenre{
  color: #3c3c3c;
  font-size: 1.6rem;
}
/* TODO scrollbar gfenres wirklich weg??*/
/*.genre .form-group, .category .form-group{*/
/*  max-height: 300px;*/
/*  overflow-y: auto;*/
/*}*/

.loading{
  padding: 3rem;
  width: 100%;
  display: flex;
  justify-content: center;
}
.loading svg{
  width: 150px;
}
.show-more{
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 3rem;
}

.output-message{
  padding: 3rem;
  text-align: center;
}

.wrap-more {
  display: flex;
  align-items: center;
  padding-bottom: .4rem;
  margin: 0 1.2rem;
  justify-content: end;
}

.wrap-more span {
  font-weight: bold;
  color: #3c3c3c;
}

.card-main-content{
  width: 100%;
}

.card-deck {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: .5rem 2rem 2rem 2rem;
  margin: 0;
}

.card-img {
  height: 100%;
  width: unset
}

.card-div {
  width: calc(100%/3 - 2rem);
  margin: 1rem;
  background: #fff;
  box-shadow: 5px 5px 15px #e3e3e3;
}

.card-div:hover {
  box-shadow: 5px 5px 15px #a4a4a4;
  cursor: pointer
}

.card-deck .card {
  background: transparent;
  border: none;
  margin: 0;
  height: 100%;
}

.card-img-wrapper {
  height: 238px;
  display: flex;
  justify-content: center;
  overflow: hidden
}

.error-picture{
  display: flex;
  height: 238px;
  align-items: center;
}
.error-picture p{
  text-align: center;
  font-size: small;
}

.card-title-wrapper {
  padding-top: 10px;
  display: flex;
  justify-content: center;
  align-items: end
}

.card-title {
  color: #3c3c3c;
  padding: 2px 0 5px 0;
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  border-bottom: 5px solid #3c3c3c;
  width: 100%;
  margin-bottom: 10px;
}

.card-content{
  margin: 0 1.2rem;
}
.card-body {
  width: 100%;
  padding: 0;
}

.card-text {
  text-align: justify;
  overflow: hidden;
  font-size: .9rem;
  margin: 0 1.2rem;
  vertical-align: text-bottom;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.form-group {
  margin-bottom: 1rem
}

.year-wrapper {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  align-items: center
}

input[type=checkbox]{
  display: none;
}
input[type=checkbox] + label {
  font-size: 1rem;
  color: #3c3c3c;
}
.checkbox-container div{
  display: flex;
  align-items: center;
}

input[type=checkbox] + label::before {
  padding-right: 5px;
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\e90d";
}

[type="checkbox"]:checked+label::before {
  content: "\e90e";
}

.search-wrap {
  background: none;
  padding-top: 2rem;
  padding-right: 2rem;
}

.checkbox-container {
  transition: height 1s;
  border-bottom: 1px solid #3c3c3c;
  display: none;
  height: 0;
}

input[type=number] {
  border: none;
  background: transparent;
  color: #3c3c3c;
  text-align: center;
  font-size: 1rem;
  -moz-appearance: textfield;
}
input[type=number]:focus{
  outline: none;
  border: none;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type=number]:invalid,
input[type=number]:out-of-range {
  border: 2px solid #ff6347;
}

.checkbox-container.extend-checkboxes {
  border-bottom: 1px solid #3c3c3c;
  display: unset;
  height: auto;
}

.search-wrap .form-control {
  background: none;
  color: #3c3c3c;
  border: none; /* site.css überschreiben */
  padding: 0;
  font-size: 1em;
  height: unset;
  margin-top: 2rem;
  border-bottom: 1px solid #3c3c3c;
}
.search-wrap .form-control:focus{
  border-bottom: 2px solid #3c3c3c;
  background: none;
  color: #3c3c3c;
  box-shadow: none;
}

.sort-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.form-group .sort-wrapper span{
  font-weight: bold;
  width: auto;
}

.sort-wrapper .form-control{
  margin-left: 20px;
}

.custom-select:focus{
  color: #495057;
  box-shadow: none;
  border: 1px solid #828282;
}

.search-wrap .search-criteria {
  width: 100%;
  margin: 0;
  color: #3c3c3c;
  font-size: .85rem;
  line-height: .85rem;
  font-weight: bold;
}

.column {
  width: 47%;
}

#searchbar-buttons {
  display: flex;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
}

#searchbar-buttons span{
  color: #3c3c3c;
}
#searchbar-buttons svg{
  stroke: #3c3c3c;
  width: 40px;
  stroke-width: 2px;
  padding-left: 5px;
}

.sorting {
  display: flex;
  flex-wrap: wrap;
  margin: 0 3rem;
  justify-content: end;
  align-items: center;
}

.sorting span {
  width: 100%;
  margin: 1rem 0 0.5rem 0;
  height: min-content;
}
.sorting .form-group {
  display: flex;
  justify-content: end;
  width: 100%;
  margin: 0
}
.extend-searchbar{
  display: flex;
  padding-bottom: 10px;
  margin-top: 2rem;
}

.extend-searchbar label.search-criteria{
  width: calc(100% - 19px);
  font-size: 1rem;
  font-weight: bold;
  line-height: 1rem;
}
.searchbar-footerline {
  margin: 3rem 0 2rem 0;
  display: flex;
  justify-content: flex-end;
}

.modal-container {
  width: 95%;
  margin: 0 2.5%
}
.modal-container .title{
  color: #3c3c3c;
  width: 100%;
  border-bottom: 5px solid #fff;
  font-size: 1.2rem;
  padding-bottom: 10px;
  margin-bottom: 2rem;
}

.title p{
  width: 100%;
  display: flex;
  margin: 0;
}

.description {
  width: 100%;
  padding-top: 1rem;
}

.modal-content {
  width: 100%;
  display: unset;
  background: transparent;
  border: none;
  flex-direction: unset
}

.modal-image {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: .5rem;
  height: 250px;
  width: 350px
}

.modal-backdrop {
  display: flex;
  background: hsla(0, 0%, 92.2%, .45);
  border-radius: 10px;
  border: 1px solid hsla(0, 0%, 100%, .18)
}

.modal {
  margin-top: 5rem;
  margin-left: 10%;
  margin-right: 10%;
  padding: 10px;
  width: 80%;
  height: 85% ;
  background: #dcdcdc;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow-y: scroll
}

.modal-footer, .modal-header {
  padding: 15px;
  display: flex
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eee;
  color: #9a1d1d;
  justify-content: space-between
}

.modal-footer {
  border-top: 1px solid #eee;
  flex-direction: column
}

.modal-body {
  position: relative;
  padding: 20px 10px
}

.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0
}

.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity .5s ease
}

.wrap-modal {
  width: 100%;
  margin: 50%
}

.modal .wrap-image .card-img {
  width: 25rem;
  /*height: 15rem*/
}

.wrap-image {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 5px solid #fff;
  padding-bottom: 2rem;
  margin-bottom: 1rem;
  justify-content: center;
}

.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: 700;
  color: #9a1d1d;
  background: transparent
}

.wrap-back-button:after {
  font-family: "icomoon";
  font-size: 2rem;
  font-weight: 400;
  content: "\e90c";
  margin-right: 10px;
  vertical-align: middle;
}

.wrap-back-button {
  height: 5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #3c3c3c;
  cursor: pointer;
}

.wrap-back-button span{
  font-weight: bold;
}

.wrap-details {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  border-bottom: 5px solid #fff;
  padding-bottom: 10px;
  margin-bottom: 20px;
  justify-content: space-between;
}

.detail-value {
  width: calc(100% - clamp(10rem, 22vw, 15rem)) ;
  margin: 0;
  padding: 0;
  font-style: italic;
}

.wrap-details p{
  width: calc(100% - 2rem);
  margin: 0.3rem 0;
  display: flex;
  justify-content: space-between;
  font-size: large
}

.strong {
  font-weight: 700;
  width: clamp(10rem, 22vw, 15rem);
}

.wrapper-fl-searchbar {
  display: flex;
  flex-wrap: wrap;
}

.searchbar {
  align-self: flex-start;
  width: calc(100% /3);
  height: min-content;
  top: 0;
}

.filmliste {
  width: calc(100% /3 * 2);
}

body, html {
  padding: 0;
  margin: 0;
}

@media (min-width: 0px) {
  .card-div{
    width: calc(100% - 2rem);
  }
  .card-main-content{
    width: 100%;
    max-width: unset;
  }
  .card-body{
    flex-wrap: wrap;
  }
}
@media (min-width: 768px) {
  .card-div{
    width: calc(100% - 2rem);
  }
  .card-main-content{
    width: 100%;
    max-width: unset;
  }
  .card-body{
    flex-wrap: wrap;
  }
}
@media (min-width: 992px) {
  .card-div{
    width: calc(100% / 2- 2rem);
  }
  .card-main-content{
    width: 100%;
    max-width: 253px;
  }
  .card-body{
    flex-wrap: unset;
  }

  .sort-wrapper .form-control{
    width: 50%;
  }

}
@media (min-width: 1200px) {
  .card-main-content{
    width: 100%;
    max-width: 313px;
  }
  .description{
    width: calc(100% - 27rem);
    padding-left: 2rem;
    padding-top: 0;
  }
  .wrap-image{
    justify-content: space-between;
  }
}
@media (max-width: 1800px){
  .modal{
    width: 75%;
    margin: 5rem 12.5% 0 12.5%;
  }
}
@media (max-width: 1200px){
  .wrap-details p {
    width: calc(100% - 2rem);
  }
  .sorting .form-group, .sorting span{
    width: 100%;
    justify-content: start;
  }
}
@media (max-width: 767px) {
  .wrap-details p{
    flex-wrap: wrap;
  }
  .wrap-details p span{
    width: 100%;
  }
  .modal .wrap-image .card-img {
    width: 100%;
    /*height: 15rem*/
  }
  .modal{
    width: 100%;
    margin: 5rem 0% 0 0%;
  }
  .searchbar{
    width: 100%;
  }
  .filmliste{
    width: 100%;
  }
  .sorting{
    margin: 1rem 0 0 0;
  }
  .card-deck{
    padding: 0;
  }
}
</style>
